<template lang="pug" src="./divider-patients.pug"></template>

<script>
import Modal from 'components/modal/modal'
import { onScroll } from 'resources/mixins'

export default {
  data () {
    return {
      modalOpen: false,
      options: {
        root: null,
        rootMargin: '0px',
        threshold: [0.4]
      }
    }
  },
  props: ['props'],
  mixins: [onScroll],
  components: {
    Modal
  },
  methods: {
    toggleModal () {
      this.$store.state.showModal ? this.$store.dispatch('VIEW_SHOWMODAL', false) : this.$store.dispatch('VIEW_SHOWMODAL', true)
      this.$store.state.showModal ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/divider/divider-patients/divider-patients.vue